import React, {useState} from 'react';
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import apiUser from "../../../apiUser";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {Alert} from "reactstrap";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import InputSearchWithButton from "../../../componentsReusable/InputSearchWithButton";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_DIAGNOSTICS_ERROR_CODE} from "../Modules";
import {useHistory} from "react-router-dom";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import {TAB_MODULES} from "../../../views/UserViews/TecRmi/MainView";
import Breadcrumb from "../../Breadcrumb";
import ComponentsTypeIdSelect from "./ComponentsTypeIdSelect";
import {isEmpty} from "lodash";
import DiagnosticErrorCode from "./DiagnosticErrorCode";
import TreeMenuNew from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import PrintButton from "../PrintButton";

const DiagnosticsErrorCode = props => {
  const { getApiPrimaryParams, ident } = useTecRmi()
  const history = useHistory();
  const [crumbs, setCrumbs] = useState([])
  const [loading, setLoading] = useState(false)
  const [itemsId, setItemsId] = useState([])

  useDidMountEffect(() => {
    if(getErrorCode()){
      findErrorCode()
    }
  })

  useAfterUpdateEffect(() => {
    findErrorCode()
  }, [props.params])

  const getComponentTypeId = () => {
    return props.params[0]
  }

  const getErrorCode = () => {
    return props.params[1]
  }

  const findErrorCode = () => {
    setItemsId([])

    if(getErrorCode() !== ''){
      setLoading(true)
      apiUser.tecRmi.diagnostics.errorCode({
        ...getApiPrimaryParams(),
        componentTypeId: getComponentTypeId(),
        errorCode: getErrorCode(),
        linkUrl: '',
      })
        .then(res => setItemsId(res.data))
        .finally(() => setLoading(false))
    }
  }

  const getMappedItems = () => {
    return itemsId.map(itemMp => ({
      key: `mainGroup-${itemMp.ItemMpId}`,
      id: itemMp.ItemMpId,
      label: itemMp.ItemMpText,
      path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_DIAGNOSTICS_ERROR_CODE, 'uriName'), [getComponentTypeId(), getErrorCode(), itemMp.ItemMpId].join('/')),
      component: DiagnosticErrorCode,
      componentProps: {
        componentTypeId: getComponentTypeId(),
        itemMp,
      }
    }))
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <Breadcrumb
          crumbs={[
            {
              name: <i className="fas fa-chevron-circle-left" />,
              path: appUserRoutes.tecRmi.tab(ident, TAB_MODULES)
            },
            {
              path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_DIAGNOSTICS_ERROR_CODE, 'uriName'), [getComponentTypeId(), getErrorCode()].join('/')),
              name: 'Dane diagnostyczne - kody błędów',
            },
            ...crumbs
          ]}
        />

        <div className="justify-content-end d-flex flex-nowrap align-items-center ml-auto">
          <div className="mr-2" style={{width: 200}}>
            <ComponentsTypeIdSelect
              onChange={_componentTypeId => {
                if(getComponentTypeId() !== _componentTypeId){
                  setCrumbs([])
                  history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_DIAGNOSTICS_ERROR_CODE, 'uriName'), _componentTypeId))
                }
              }}
              value={getComponentTypeId()}
            />
          </div>
          <PrintButton />
          <InputSearchWithButton
            onInputChanged={errorCode => {
              history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_DIAGNOSTICS_ERROR_CODE, 'uriName'), [getComponentTypeId(), errorCode].join('/')))
            }}
            value={getErrorCode()}
          />
        </div>
      </div>

      <div className="mt-2">
        {loading
          ? <LoadingSpinner/>
          : (
            isEmpty(itemsId)
              ? <Alert color={'warning'} className="text-center">Brak danych</Alert>
              : <TreeMenuNew
                actives={props.params.slice(2)}
                items={getMappedItems()}
                onCrumbsChanged={setCrumbs}
              />
          )
        }
      </div>
    </div>
  );
};

DiagnosticsErrorCode.defaultProps = {
  params: [],
};

export default DiagnosticsErrorCode;